import { Box, Grid, IconButton, Paper } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Formik } from "formik";
import qs from "query-string";
import React from "react";
import { Link, useHistory } from "react-router-dom";

import { Center } from "../../../../components/center";
import { DateInput } from "../../../../components/date_input";
import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import { ISingleProductFilter, singleProductFilterToQueryParams } from "./single_product_history_list";

function singleProductHistoryQueryParamsToFilter(queryString: string, productId: string): ISingleProductFilter {
  const queryParams = qs.parse(queryString);
  const filter: ISingleProductFilter = {
    productId,
  };

  Object.keys(queryParams).forEach((key) => {
    if (key.includes("filter")) {
      const query = queryParams[key]?.toString();

      if (query) {
        const parsed = query.split("||");
        const filterKey = parsed[0];
        const condition = parsed[1];
        const filterValue = parsed[2];

        if (filterKey === "createdDate" && condition === "$gte") {
          filter.createdDateRange = {
            from: new Date(filterValue),
            to: filter.createdDateRange?.to,
          };
        } else if (filterKey === "createdDate" && condition === "$lte") {
          filter.createdDateRange = {
            to: new Date(filterValue),
            from: filter.createdDateRange?.from,
          };
        }
      }
    }
  });

  return filter;
}

interface IProps {
  productId: string;
}

const todayDate = new Date();

export const SingleProductHistoryFilter: React.FC<IProps> = ({ productId }) => {
  const history = useHistory();

  const initialFilter: ISingleProductFilter = {
    createdDateRange: {
      from: todayDate,
      to: todayDate,
    },
    productId,
  };

  function onSubmit(values: ISingleProductFilter) {
    history.push({
      search: singleProductFilterToQueryParams(values),
    });
  }

  const initialValues = history.location.search
    ? singleProductHistoryQueryParamsToFilter(history.location.search, productId)
    : initialFilter;

  return (
    <Box mt={3}>
      <Formik<ISingleProductFilter> initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
        {({ values, submitForm, setFieldValue }) => {
          return (
            <Paper>
              <Box px={2}>
                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item sm={3}>
                    <DateInput
                      label="Tarixdən"
                      name="createdDateRange.from"
                      maxDate={values.createdDateRange?.to}
                      onChange={() => {
                        submitForm();
                      }}
                      setFieldValue={setFieldValue}
                    />
                  </Grid>

                  <Grid item sm={3}>
                    <DateInput
                      label="Tarixə"
                      name="createdDateRange.to"
                      minDate={values.createdDateRange?.from}
                      maxDate={todayDate}
                      onChange={() => {
                        submitForm();
                      }}
                      setFieldValue={setFieldValue}
                    />
                  </Grid>

                  <Grid item sm={1}>
                    <Center>
                      <IconButton to={Routing.generateDetailRoute(ROUTES.product, productId)} component={Link}>
                        <CloseIcon />
                      </IconButton>
                    </Center>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          );
        }}
      </Formik>
    </Box>
  );
};
